<script>

	import 'flatpickr/dist/flatpickr.css'
    
    import Moment from 'moment'
    import Flatpickr from 'svelte-flatpickr'

    export let label = ''
    export let value = Moment().startOf('day').toDate()
    
    export let minDate = null
    export let maxDate = null
    export let showTime = true

    export let setFormat = null

    const options = {
        minDate,
        maxDate,
        altInput: true,
        allowInput: true,
        disableMobile: true,
        enableTime: showTime,
        formatDate: (date, format, locale) => {

            if(!setFormat)
                return Moment(value).locale('es').format(showTime? 'dddd DD MMMM YYYY h:mm A' : 'dddd DD MMMM YYYY')

            return Moment(value).locale('es').format(setFormat)
        },
        parseDate: (datestr, format) => {
            return Moment(value).locale('es').toDate()
        }
    }

</script>

<div class="field">
    {#if label}
        <label for="" class="label">{ label }</label>
    {/if}
    <div class="control">
        <Flatpickr on:change {options} bind:value />
    </div>
</div>